/** Without a `<` followed by a letter, `/`, `!` or `?`, an HTML parser cannot build any element or comment from the text. */
const MARKUP_PATTERN = /<[a-z/!?]/i;
export function isDescriptionHtml(value) {
    return MARKUP_PATTERN.test(value);
}
//# sourceMappingURL=is-description-html.js.map